import { render, staticRenderFns } from "./DocumentPOSTotalGroups.vue?vue&type=template&id=33909e9e"
import script from "./DocumentPOSTotalGroups.vue?vue&type=script&lang=js"
export * from "./DocumentPOSTotalGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports